import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/Header";
import TabHeader from "../../components/TabHeader";
import LoaderImage from "../../images/ohhto-loading.gif";
import MenuIcon from "../../images/horizontal-icon.svg";
import ImageInput from "../../components/ImageInput";
import CropPopup from "../../components/CropPopup";
import CountryCode from "../../config/countryCode.json";
import Input from "../../components/Input";
import { useSelector } from "react-redux";
import axios from "../../helpers/axios";
import { dataURItoBlob, getCountryFromCodeSettings } from "../../helpers/utils";
import { IMAGE_BASE_URL } from "../../helpers/constants";
import CustomSelect from "../../components/CustomSelect";
import { useParams } from "react-router-dom";
import CustomerConfirmationPopup from "../../components/CustomerConfirmationPopup";
import POC from "./components/POC";
import Moment from "moment";
import { toast } from "react-toastify";

export default function CustomersInfo() {
  const { id } = useParams();
  const [featureModal, setFeatureModal] = useState();
  const [banModal, setBanModal] = useState();
  const [rejectModal, setRejectModal] = useState();
  const [approveModal, setApproveModal] = useState();
  const [tabData, setTabData] = useState([
    { label: "Manage Dealer", value: 1 },
    // { label: "Manage Loan Product", value: 0 },
  ]);
  const [activeTab, setActiveTab] = useState(1);
  const authInfo = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState(true);
  const [menuPopup, setMenuPopup] = useState(false);
  const formRef = useRef(null);
  const ref = useRef(null);
  const dropRef = useRef(null);

  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    passwordMatch: false,
    icon: "",
    country_code: "+65",
    phone_number: null,
    featured: 0,
    status: 0,
    address_line1: "",
    address_line2: "",
    country: "sg",
    postal_code: null
  });

  //console.log("data", data)

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      ref.current &&
      (!ref.current.contains(event.target) ||
        !dropRef.current.contains(event.target))
    ) {
      // setMenuPopup(false);
    }
  };

  useEffect(() => {
    async function getAgentInfo() {
      setLoading(true);
      let res = await axios.get(
        `/admin/customer/info/${id}`
      );
      setData({
        ...res.data.data,
        icon: res.data.data?.avatar
      });
      setLoading(false);
    }
    getAgentInfo();
  }, [activeTab]);

  const confirmFeatured = async () => {
    try {
      let res = await axios.put(`/admin/customer/status/update${id}/${!data.featured}`, {
        ...data,
        featured: !data.featured,
      });
      setFeatureModal(false);
      setData((data) => ({ ...data, featured: !data.featured }));
      toast.success(res.data?.message);

    } catch (error) {
      //console.log(error);
      alert(error);
    }
  };

  const confirmBan = async () => {
    try {
      let res = await axios.put(`/admin/customer/status/update/${id}/3`, {
        ...data,
        status: 3,
      });
      setData((data) => ({ ...data, status: 3 }));
      setBanModal(false);
      toast.success(res.data?.message);
    } catch (error) {
      //console.log(error);
      alert(error);
    }
  };

  const confirmReject = async () => {
    try {
      let res = await axios.put(`/admin/customer/status/update/${id}/2`, {
        ...data,
        status: 2,
      });
      setData((data) => ({ ...data, status: 2 }));
      setRejectModal(false);
      toast.success(res.data?.message);

    } catch (error) {
      //console.log(error);
      alert(error);
    }
  };

  const confirmApprove = async () => {
    try {
      let res = await axios.put(`/admin/customer/status/update/${id}/1`, {
        ...data,
        status: 1,
      });
      setData((data) => ({ ...data, status: 1 }));
      setApproveModal(false);
      toast.success(res.data?.message);

    } catch (error) {
      //console.log(error);
      alert(error);
    }
  };

  const RightContent = () => {
    return !loading ? (
      <div className="relative">
        <div className="hidden md:flex justify-between w-full md:justify-end">
          {activeTab === 1 ? (
            viewMode ? (
              <div>
                <button
                  className="btn-sm-disabled mr-1 md:mr-3"
                  onClick={() => setViewMode(false)}
                >
                  Edit
                </button>
                {data.status !== 3 || data.status !== 0 ? (
                  <button
                    className="btn-sm-disabled mr-1 md:mr-3"
                    onClick={() => setBanModal(true)}
                  >
                    Ban
                  </button>
                ) : null}
                {/* {data.status !== 2 ? (
                  <button
                    className="btn-sm-red mr-1 md:mr-3"
                    onClick={() => setRejectModal(true)}
                  >
                    Reject
                  </button>
                ) : null} */}
                {data.status !== 1 ? (
                  <button
                    className="btn-sm"
                    onClick={() => setApproveModal(true)}
                  >
                    Approve
                  </button>
                ) : null}
              </div>
            ) : (
              <div>
                <button
                  className="btn-sm-disabled mr-1 md:mr-3"
                  onClick={() => setViewMode(true)}
                >
                  Cancel
                </button>
                <button type="submit" form="edit-customer" className="btn-sm">
                  Save
                </button>
              </div>
            )
          ) : null}
        </div>
        <div>
          {viewMode ? (
            <div
              className="md:hidden mr-4"
              ref={ref}
              onClick={() => setMenuPopup(!menuPopup)}
            >
              <div className="flex justify-center w-5 h-5 items-center gap-2 rounded-md font-medium bg-white align-middle  transition-all">
                <img src={MenuIcon} className="w-full h-full md:w-10 md:h-10" />
              </div>
            </div>
          ) : (
            <div className="md:hidden">
              <button
                className="btn-sm-disabled mr-2 md:mr-3"
                onClick={() => setViewMode(true)}
              >
                Cancel
              </button>
              <button type="submit" form="edit-customer" className="btn-sm">
                Save
              </button>
            </div>
          )}
        </div>
        <div ref={dropRef}>
          {menuPopup && viewMode ? (
            <div className="absolute bg-white shadow-lg shadow-slate-200 border z-[99] border-gray-200 rounded-lg w-[90px] top-[38px] right-[10%] overflow-hidden">
              <div
                className="flex px-4  py-2 w-full hover:bg-slate-50 cursor-pointer"
                onClick={() => setViewMode(false)}
              >
                <p className="text-sm md:text-xs font-medium  tracking-[-.25px] text-gray-700">
                  Edit
                </p>
              </div>
              <div
                className="flex px-4  py-2 w-full hover:bg-slate-50 cursor-pointer"
                onClick={() => setBanModal(true)}
              >
                <p className="text-sm md:text-xs font-medium  tracking-[-.25px] text-gray-700">
                  Ban
                </p>
              </div>
              <div
                className="flex px-4  py-2 w-full hover:bg-slate-50 cursor-pointer"
                onClick={() => setRejectModal(true)}
              >
                <p className="text-sm md:text-xs font-medium  tracking-[-.25px] text-gray-700">
                  Reject
                </p>
              </div>
              <div
                className="flex px-4  py-2 w-full hover:bg-slate-50 cursor-pointer"
                onClick={() => setApproveModal(true)}
              >
                <p className="text-sm md:text-xs font-medium  tracking-[-.25px] text-red-500">
                  Approve
                </p>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    ) : (
      <div className="absolute z-50 left-0 top-0 w-full h-full  flex items-center justify-center">
        <img src={LoaderImage} className="w-24 h-24" />
      </div>
    );
  };
  return !loading ? (
    <div className="flex flex-col w-full h-full">
      <Header title={"Customer Account"} RightContent={RightContent} />
      {/* <TabHeader data={tabData} active={activeTab} setActive={setActiveTab} /> */}
      <div className="flex-1 h-full w-full overflow-y-scroll">
        {!loading && (
          <ManageDealerForm
            setViewMode={setViewMode}
            formRef={formRef}
            id={id}
            updateData={data}
            viewMode={viewMode}
          />
        )}
      </div>
      {featureModal ? (
        <CustomerConfirmationPopup
          type={"feature"}
          onClose={() => setFeatureModal(false)}
          setActiveData={setData}
          activeData={data}
          onConfirm={confirmFeatured}
        />
      ) : null}
      {banModal ? (
        <CustomerConfirmationPopup
          type={"ban"}
          onClose={() => setBanModal(false)}
          setActiveData={setData}
          activeData={data}
          onConfirm={confirmBan}
        />
      ) : null}
      {rejectModal ? (
        <CustomerConfirmationPopup
          type={"reject"}
          onClose={() => setRejectModal(false)}
          setActiveData={setData}
          activeData={data}
          onConfirm={confirmReject}
        />
      ) : null}
      {approveModal ? (
        <CustomerConfirmationPopup
          type={"approve"}
          onClose={() => setApproveModal(false)}
          setActiveData={setData}
          activeData={data}
          onConfirm={confirmApprove}
        />
      ) : null}
    </div>
  ) : (
    <div className="absolute z-50 left-0 top-0 w-full h-full  flex items-center justify-center">
      <img src={LoaderImage} className="w-24 h-24" />
    </div>
  );
}

const ManageDealerForm = ({ updateData, viewMode, id, setViewMode }) => {
  const [image, setImage] = useState(null);
  const [showCrop, setShowCrop] = useState(false);
  const [croppedImage, setCroppedImage] = useState();
  const settings = useSelector((state) => state.settings);
  const [errors, setErrors] = useState();
  const [createData, setCreateData] = useState(updateData);
  const [editPassword, setEditPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setShowCrop(true);
      setImage(URL.createObjectURL(event.target.files[0]));
      setCreateData((data) => ({ ...data, icon: "" }));
    }
  };



  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      setEditPassword(false);
      setErrors(false);
      if (editPassword && createData.password !== createData.confirmPassword) {
        setErrors((data) => ({
          ...data,
          confirmPassword: "Password does not match",
        }));
        return false;
      }
      if (!croppedImage && !createData.icon) {
        setErrors((data) => ({ ...data, icon: "Please upload the logo" }));
        return false;
      }
      setLoading(true);
      let blobFile = await dataURItoBlob(croppedImage);
      let formData = new FormData();
      formData.append("file", blobFile, "crop-icon.jpg");
      formData.append("module", "customer");
      let fileRes = await axios.post("/admin/upload/image", formData);

      let res = await axios.put(`/admin/customer/update/${id}`, {
        ...createData,
        avatar: createData.icon ? createData.icon : fileRes.data.data,
      });
      if (res.status < 400) {
        setViewMode(true);
        toast.success(res.data?.message);
      }
    } catch (error) {
      Object.keys(error.response.data.errors).forEach(function (key) {
        toast.error(
          error.response.data.errors[key] !== undefined
            ? error.response.data.errors[key]
            : "Error occured profile not updated..!"
        );
      });
    }
  };

  // const onCrate
  return (
    <>
      <div className="py-4 px-4 md:py-8 md:px-9 w-full bg-white">
        <form id="edit-customer" className="w-full max-w-xl" onSubmit={onSubmit}>
          <div className="grid grid-cols-1 gap-x-3 gap-y-1 md:gap-y-4">
            {viewMode ? (
              <div className="userInfo">
                <div className="grid grid-cols-8 gap-x-3">
                  <div className="col-span-4">
                    <label>Created On</label>
                    <p class="md:text-sm text-black ">
                      {Moment(createData.created_at).format(
                        "DD-MM-YYYY HH:MM"
                      )}
                    </p>
                  </div>
                  <div className="col-span-4">
                    <label>Customer Status</label>
                    <p class="md:text-sm text-black ">
                      {createData.status == 0
                        ? "Pending"
                        : createData.status == 1
                          ? "Approved"
                          : createData.status == 2
                            ? "Rejected"
                            : createData.status == 3
                              ? "Banned"
                              : ""}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="col-span-2">
              <label>Customer Name</label>
              <Input
                required={true}
                viewMode={viewMode}
                value={createData.name}
                placeholder={"Enter Full Name"}
                setValue={(value) =>
                  setCreateData((data) => ({ ...data, name: value }))
                }
                error={errors ? errors["name"] : null}
              />
            </div>
            <div className="col-span-2">
              <label>Customer Email</label>
              <Input
                type="email"
                required={true}
                viewMode={viewMode}
                value={createData.email}
                placeholder={"Enter Email address"}
                setValue={(value) =>
                  setCreateData((data) => ({ ...data, email: value }))
                }
                error={errors ? errors["email"] : null}
              />
            </div>
            <div className="col-span-1">
              <div className="flex justify-between">
                <label>Password</label>{" "}
                {editPassword || viewMode ? null : (
                  <p
                    className="text-xs text-blue-600 font-medium tracking-tight cursor-pointer"
                    onClick={() => setEditPassword(!editPassword)}
                  >
                    Set Password
                  </p>
                )}
              </div>
              <Input
                type="password"
                value={createData.password}
                disabled={viewMode || !editPassword}
                required={editPassword}
                viewMode={viewMode}
                placeholder={"Enter Password"}
                setValue={(value) =>
                  setCreateData((data) => ({ ...data, password: value }))
                }
                error={errors?.password}
              />
            </div>
            <div className="col-span-1">
              {viewMode || !editPassword ? null : (
                <>
                  <label>Confirm Password</label>
                  <Input
                    type="password"
                    value={createData.confirmPassword}
                    disabled={viewMode || !editPassword}
                    required={editPassword}
                    viewMode={viewMode}
                    placeholder={"Confirm Password"}
                    setValue={(value) =>
                      setCreateData((data) => ({
                        ...data,
                        confirmPassword: value,
                      }))
                    }
                    error={errors?.confirmPassword}
                  />
                </>
              )}
            </div>
          </div>
          <div>
            <p className="text-sm tracking-tight font-semibold mt-0 mb-4 md:mt-5 md:mb-7">
              Customer Details
            </p>
            <div className="grid grid-cols-3 gap-x-3 gap-y-1 md:gap-y-4">
              <div className={`${viewMode ? "mb-3" : ""}`}>
                <label>Customer&apos;s Profile</label>
                {viewMode ? (
                  <img
                    src={
                      createData.icon
                        ? `${IMAGE_BASE_URL}/${createData.icon}`
                        : croppedImage
                    }
                    className="h-6 w-6 rounded-md"
                  />
                ) : (
                  <ImageInput
                    viewMode={viewMode}
                    image={
                      createData.icon && createData.icon !== ""
                        ? `${IMAGE_BASE_URL}/${createData.icon}`
                        : croppedImage
                    }
                    setImage={onImageChange}
                    error={errors ? errors["icon"] : null}
                  />
                )}
                {/* <ImageInput image={croppedImage} setImage={onImageChange}/> */}
              </div>

              <div className="col-span-2 gap-x-2">
                <div className="flex md:grid md:grid-cols-4 justify-between gap-x-3">
                  <div>
                    <label>Country Code</label>
                    {viewMode ? (
                      <p className="text-sm text-black">
                        {createData.country_code}
                      </p>
                    ) : (
                      <CustomSelect
                        customLabel={"dial_code"}
                        customValue={"dial_code"}
                        required={true}
                        disabled={viewMode}
                        placeholder={"Select Country Code"}
                        options={CountryCode}
                        value={createData.country_code}
                        setValue={(value) =>
                          setCreateData((data) => ({
                            ...data,
                            country_code: value,
                          }))
                        }
                      />
                    )}
                  </div>
                  <div className="col-span-3 flex-1 flex-grow">
                    <label>Contact Number</label>
                    <Input
                      number={true}
                      type="text"
                      value={createData.phone_number}
                      required={true}
                      viewMode={viewMode}
                      placeholder={"Contact Number"}
                      setValue={(value) =>
                        setCreateData((data) => ({
                          ...data,
                          phone_number: value,
                        }))
                      }
                      maxLength={8}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className=" mt-3">
              <div>
                <label>{viewMode ? "Address Line 1" : "Address"}</label>
                <Input
                  type="text"
                  value={createData.address_line1}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Address 1 ( Floor, Unit No., Street Name)"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, address_line1: value }))
                  }
                />
              </div>
            </div>
            <div className="mt-3">
              <div>
                {viewMode ? <label>Address Line 2</label> : null}
                <Input
                  type="text"
                  value={createData.address_line2}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Address 2 (Building name, other info)"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, address_line2: value }))
                  }
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-x-3 mt-3">
              <div>
                {viewMode ? <label>Postal Code</label> : null}
                <Input
                  number={true}
                  type="text"
                  value={createData.postal_code}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Postal Code"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, postal_code: value }))
                  }
                />
              </div>
              <div>
                {viewMode ? <label>Country</label> : null}
                {viewMode ? (
                  <p className="text-sm text-black">
                    {getCountryFromCodeSettings(createData.country)}
                  </p>
                ) : (
                  <CustomSelect
                    required={true}
                    disabled={viewMode}
                    placeholder={"Select Country"}
                    customValue={"code"}
                    options={CountryCode}
                    value={createData.country}
                    setValue={(value) =>
                      setCreateData((data) => ({ ...data, country: value }))
                    }
                    error={errors ? errors["country"] : null}
                  />
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
      {showCrop ? (
        <CropPopup
          image={image}
          setActive={setShowCrop}
          setImage={setCroppedImage}
        />
      ) : null}
    </>
  );
};
